/* ==========================================================================
   AmpBird Product Hero V3 — gallery controller
   - Thumb click -> switch main image (fade, no layout shift)
   - Prev / Next arrows + counter
   - Variant sync via PUB_SUB_EVENTS.variantChange
   - Lightbox (zoom icon, click main image, keyboard, swipe, pan)
   - Horizontal thumbnail scroll buttons + touch swipe
   ========================================================================== */
(function () {
  'use strict';

  function setActive(root, index) {
    var thumbs = root.querySelectorAll('[data-amphero-thumbs] .amphero-v3__thumb');
    var slides = root.querySelectorAll('[data-amphero-viewport] .amphero-v3__slide');
    var counter = root.querySelector('[data-amphero-counter]');
    if (!slides.length) return;
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    for (var i = 0; i < thumbs.length; i++) {
      var active = (parseInt(thumbs[i].getAttribute('data-index'), 10) === index);
      thumbs[i].classList.toggle('is-active', active);
      thumbs[i].setAttribute('aria-selected', active ? 'true' : 'false');
    }
    for (var j = 0; j < slides.length; j++) {
      var isActive = (parseInt(slides[j].getAttribute('data-index'), 10) === index);
      slides[j].classList.toggle('is-active', isActive);
      if (isActive) {
        slides[j].removeAttribute('hidden');
      } else {
        slides[j].setAttribute('hidden', '');
      }
    }
    if (counter) {
      counter.textContent = (index + 1) + ' / ' + slides.length;
    }
    root._v3Active = index;
  }

  function setLightboxActive(lightbox, index) {
    var slides = lightbox.querySelectorAll('[data-amphero-lightbox-viewport] .amphero-v3__lightbox-slide');
    var counter = lightbox.querySelector('[data-amphero-lightbox-counter]');
    if (!slides.length) return;
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    for (var j = 0; j < slides.length; j++) {
      var isActive = (parseInt(slides[j].getAttribute('data-index'), 10) === index);
      slides[j].classList.toggle('is-active', isActive);
      if (isActive) {
        slides[j].removeAttribute('hidden');
      } else {
        slides[j].setAttribute('hidden', '');
      }
    }
    if (counter) {
      counter.textContent = (index + 1) + ' / ' + slides.length;
    }
    lightbox._v3Active = index;

    /* Reset zoom on slide change */
    var stage = lightbox.querySelector('[data-amphero-lightbox-stage]');
    if (stage) {
      stage.classList.remove('is-zoomed', 'is-panning');
      stage.style.cursor = 'zoom-in';
      var img = lightbox.querySelector('.amphero-v3__lightbox-slide.is-active img');
      if (img) {
        img.style.transform = '';
        img.style.marginLeft = '';
        img.style.marginTop = '';
      }
    }
  }

  function openLightbox(root, index) {
    var lightbox = root.querySelector('[data-amphero-lightbox]');
    if (!lightbox) return;
    lightbox.removeAttribute('hidden');
    // force reflow
    void lightbox.offsetWidth;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setLightboxActive(lightbox, typeof index === 'number' ? index : (root._v3Active || 0));
  }

  function closeLightbox(lightbox) {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      lightbox.setAttribute('hidden', '');
    }, 200);
  }

  function scrollThumbs(root, direction) {
    var thumbs = root.querySelector('[data-amphero-thumbs]');
    if (!thumbs) return;
    var amount = 84; // thumb 72 + gap 12
    thumbs.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  function updateScrollButtons(root) {
    var thumbs = root.querySelector('[data-amphero-thumbs]');
    var prev = root.querySelector('[data-amphero-scroll-prev]');
    var next = root.querySelector('[data-amphero-scroll-next]');
    if (!thumbs || !prev || !next) return;
    var canScrollLeft = thumbs.scrollLeft > 2;
    var canScrollRight = thumbs.scrollLeft + thumbs.clientWidth < thumbs.scrollWidth - 2;
    prev.classList.toggle('is-visible', canScrollLeft);
    next.classList.toggle('is-visible', canScrollRight);
  }

  function addSwipe(element, onLeft, onRight) {
    if (!element) return;
    var startX = 0;
    var startY = 0;
    var isDragging = false;

    element.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    element.addEventListener('touchmove', function () {
      /* noop, we only need start/end */
    }, { passive: true });

    element.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var endX = e.changedTouches[0].clientX;
      var endY = e.changedTouches[0].clientY;
      var diffX = startX - endX;
      var diffY = startY - endY;
      if (Math.abs(diffX) < 40 || Math.abs(diffY) > Math.abs(diffX)) return;
      if (diffX > 0) {
        onLeft();
      } else {
        onRight();
      }
    }, { passive: true });
  }

  function addPan(lightbox) {
    var stage = lightbox.querySelector('[data-amphero-lightbox-stage]');
    var img = lightbox.querySelector('.amphero-v3__lightbox-slide.is-active img');
    if (!stage || !img) return;

    var isPanning = false;
    var startX = 0, startY = 0, currentX = 0, currentY = 0;

    stage.addEventListener('mousedown', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      isPanning = true;
      stage.classList.add('is-panning');
      startX = e.clientX - currentX;
      startY = e.clientY - currentY;
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!isPanning) return;
      currentX = e.clientX - startX;
      currentY = e.clientY - startY;
      img.style.marginLeft = currentX + 'px';
      img.style.marginTop = currentY + 'px';
    });

    window.addEventListener('mouseup', function () {
      if (!isPanning) return;
      isPanning = false;
      stage.classList.remove('is-panning');
    });
  }

  function initGallery(root) {
    if (root._v3Init) return;
    root._v3Init = true;

    var thumbs = root.querySelectorAll('[data-amphero-thumbs] .amphero-v3__thumb');
    var prev = root.querySelector('[data-amphero-prev]');
    var next = root.querySelector('[data-amphero-next]');
    var openBtn = root.querySelector('[data-amphero-open-lightbox]');
    var stage = root.querySelector('[data-amphero-stage]');
    var scrollPrev = root.querySelector('[data-amphero-scroll-prev]');
    var scrollNext = root.querySelector('[data-amphero-scroll-next]');
    var thumbsContainer = root.querySelector('[data-amphero-thumbs]');

    for (var i = 0; i < thumbs.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          setActive(root, parseInt(btn.getAttribute('data-index'), 10));
        });
      })(thumbs[i]);
    }
    if (prev) prev.addEventListener('click', function () { setActive(root, (root._v3Active || 0) - 1); });
    if (next) next.addEventListener('click', function () { setActive(root, (root._v3Active || 0) + 1); });

    if (openBtn) openBtn.addEventListener('click', function () { openLightbox(root, root._v3Active || 0); });
    if (stage) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest('.amphero-v3__nav') || e.target.closest('.amphero-v3__zoom')) return;
        openLightbox(root, root._v3Active || 0);
      });
    }

    if (scrollPrev) scrollPrev.addEventListener('click', function () { scrollThumbs(root, -1); });
    if (scrollNext) scrollNext.addEventListener('click', function () { scrollThumbs(root, 1); });
    if (thumbsContainer) {
      thumbsContainer.addEventListener('scroll', function () { updateScrollButtons(root); });
      window.addEventListener('resize', function () { updateScrollButtons(root); }, { passive: true });
      updateScrollButtons(root);
    }

    /* Swipe on main stage */
    addSwipe(stage, function () { setActive(root, (root._v3Active || 0) + 1); }, function () { setActive(root, (root._v3Active || 0) - 1); });

    /* Variant sync: when a variant changes, switch to its featured media */
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event, payload) {
        var data = (payload && payload.data) ? payload.data : (payload || {});
        if (!data) return;
        var sectionId = data.sectionId || (data.section && data.section.id);
        if (sectionId && root.getAttribute('data-section-id') !== String(sectionId)) return;
        var variant = data.variant;
        if (!variant || !variant.featured_media) return;
        var mediaId = variant.featured_media.id;
        var slide = root.querySelector('.amphero-v3__slide[data-media-id$="-' + mediaId + '"]');
        if (slide) setActive(root, parseInt(slide.getAttribute('data-index'), 10));
      });
    }
  }

  function initLightbox(root) {
    var lightbox = root.querySelector('[data-amphero-lightbox]');
    if (!lightbox || lightbox._v3Init) return;
    lightbox._v3Init = true;

    var closeBtn = lightbox.querySelector('[data-amphero-lightbox-close]');
    var lbPrev = lightbox.querySelector('[data-amphero-lightbox-prev]');
    var lbNext = lightbox.querySelector('[data-amphero-lightbox-next]');
    var stage = lightbox.querySelector('[data-amphero-lightbox-stage]');

    if (closeBtn) closeBtn.addEventListener('click', function () { closeLightbox(lightbox); });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === stage) closeLightbox(lightbox);
    });

    if (lbPrev) lbPrev.addEventListener('click', function () { setLightboxActive(lightbox, (lightbox._v3Active || 0) - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { setLightboxActive(lightbox, (lightbox._v3Active || 0) + 1); });

    addSwipe(stage, function () { setLightboxActive(lightbox, (lightbox._v3Active || 0) + 1); }, function () { setLightboxActive(lightbox, (lightbox._v3Active || 0) - 1); });

    /* Zoom toggle on stage click (not on nav/close) */
    if (stage) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest('.amphero-v3__lightbox-nav') || e.target.closest('.amphero-v3__lightbox-close')) return;
        stage.classList.toggle('is-zoomed');
        if (!stage.classList.contains('is-zoomed')) {
          var img = lightbox.querySelector('.amphero-v3__lightbox-slide.is-active img');
          if (img) {
            img.style.transform = '';
            img.style.marginLeft = '';
            img.style.marginTop = '';
          }
          stage.classList.remove('is-panning');
        }
      });
    }

    addPan(lightbox);

    /* Keyboard */
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        closeLightbox(lightbox);
      } else if (e.key === 'ArrowLeft') {
        setLightboxActive(lightbox, (lightbox._v3Active || 0) - 1);
      } else if (e.key === 'ArrowRight') {
        setLightboxActive(lightbox, (lightbox._v3Active || 0) + 1);
      }
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-amphero]');
    for (var i = 0; i < roots.length; i++) {
      initGallery(roots[i]);
      initLightbox(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme Editor: re-init on section load */
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    var roots = target.querySelectorAll ? target.querySelectorAll('[data-amphero]') : [];
    for (var i = 0; i < roots.length; i++) {
      initGallery(roots[i]);
      initLightbox(roots[i]);
    }
  });
})();
